export default __webpack_public_path__ + "static/media/logo.f4cc4263.svg";